import './EmptyState.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var actionsSlotCss = '_1r84lsw9-2-0-1';
export var contentContainerCss = '_1r84lsw6-2-0-1';
export var detailsSlotCss = '_1r84lsw8-2-0-1';
export var emptyStateContainerCss = _7a468({defaultClassName:'_1r84lsw0-2-0-1',variantClassNames:{size:{small:'_1r84lsw1-2-0-1','default':'_1r84lsw2-2-0-1',large:'_1r84lsw3-2-0-1',largeResponsive:'_1r84lsw4-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var footerSlotCss = '_1r84lswa-2-0-1';
export var titleSlotCss = '_1r84lsw7-2-0-1';
export var visualSlotCss = '_1r84lsw5-2-0-1';